import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import classnames from 'classnames';
import filter from 'lodash/filter';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { getBrandTag } from 'components/Brands';
import { hasTag } from 'components/Content/utils';
import { getContentTaggedAnyOfBrandsTags } from 'components/Content/byBrand';
import { useIsMobile } from 'utils/hooks';
import { dataLayerPush } from 'utils/tracking';
import styles from './styles.scss';

// TODO move to Content/byBrand when refactoring
// returns a single content object.
// finds all content tagged with any of given brand's tags,
// but prioritizes returning content tagged specifically with the given brand
const getContentByBrand = (c, brand) => {
  c = getContentTaggedAnyOfBrandsTags(c, brand);

  if (!c?.length) return c;

  const cCurrentBrandOnly = filter(c, (ci) => hasTag(ci, getBrandTag(brand)));

  return cCurrentBrandOnly.length ? cCurrentBrandOnly[0] : c[0];
};

const MarketingPromotionDetails = ({
  dialog,
  brand,
  branch,
  onView,
  history,
}) => {
  const {
    fields,
    fields: { imageLink },
  } = dialog;

  const pushDataLayer = (event) =>
    dataLayerPush('SelfServe', {
      event,
      section: 'Promo Dialog',
      brand,
      branch,
      promoHandle: dialog.promoHandle,
    });

  const isMobile = useIsMobile();
  const [showDialog, changeShowDialog] = useState(false);

  useEffect(() => {
    // Delay the showing of the Dialog until the image is loaded
    setTimeout(() => {
      changeShowDialog(true);
      pushDataLayer('promotion-view');
      onView();
    }, 500);
  }, []);

  const image = getContentByBrand(fields.image, brand);

  if (!image) return null;

  const text = getContentByBrand(fields.text, brand);
  const richText = text && documentToReactComponents(text);

  const {
    description: imgDx,
    file: { url: imgSrc },
  } = image.fields;

  const onOrderNow = () => {
    if (!imageLink) return;
    pushDataLayer('promotion-click');
    history.push(imageLink);
  };

  return showDialog || isMobile ? (
    <div className={styles.promotionDetails}>
      <div
        className={classnames(styles.promotionImage, {
          [styles.promotionImageClickable]: imageLink,
        })}
        onClick={onOrderNow}
        onKeyDown={onOrderNow}
        role="button"
        tabIndex="0"
      >
        <img src={imgSrc} alt={imgDx} />
      </div>
      {richText && <div className={styles.promotionTextStyle}>{richText}</div>}
    </div>
  ) : (
    <div className={styles.promotionDetailsLoading}></div>
  );
};

MarketingPromotionDetails.propTypes = {
  dialog: PropTypes.object,
};

export default withRouter(MarketingPromotionDetails);
